import React from "react";

/*
 * THE LEAD'S COUNTRY, AS A FLAG.
 *
 * companies.country holds a full English name, the way Apollo writes it ("United
 * States", "Taiwan, Province of China"), and a few spellings of the same place
 * ("Netherlands" and "The Netherlands"). The map is keyed lowercase and covers
 * every value on the table as of 2026-09-29 plus the neighbours we are likely to
 * see next. A name it does not know draws nothing rather than a wrong flag.
 *
 * AN IMAGE, NOT AN EMOJI. Windows has no flag glyphs: the regional-indicator pair
 * renders as the two letters "US" in a box, and Windows is where the board is
 * read. flagcdn serves the flags as small PNGs keyed by the same ISO code; if it
 * is unreachable the alt text is the code, which is still the answer.
 */
const COUNTRY_CODES = {
  "united states": "us", "united states of america": "us", usa: "us",
  israel: "il",
  "united kingdom": "gb", uk: "gb", "great britain": "gb", england: "gb", scotland: "gb", wales: "gb", "northern ireland": "gb",
  canada: "ca", india: "in", germany: "de", switzerland: "ch", france: "fr", sweden: "se",
  australia: "au", netherlands: "nl", "the netherlands": "nl", finland: "fi", norway: "no",
  italy: "it", singapore: "sg", iceland: "is", spain: "es", ireland: "ie", portugal: "pt",
  denmark: "dk", malta: "mt", "united arab emirates": "ae", uae: "ae", poland: "pl", turkey: "tr", "türkiye": "tr",
  "russian federation": "ru", russia: "ru", "czech republic": "cz", czechia: "cz", cyprus: "cy",
  ukraine: "ua", "saudi arabia": "sa", argentina: "ar", china: "cn", belgium: "be", hungary: "hu",
  brazil: "br", guernsey: "gg", jersey: "je", "isle of man": "im", colombia: "co", "new zealand": "nz",
  "south africa": "za", peru: "pe", serbia: "rs", romania: "ro", taiwan: "tw", "taiwan, province of china": "tw",
  afghanistan: "af", "hong kong": "hk", austria: "at", luxembourg: "lu", greece: "gr", estonia: "ee",
  latvia: "lv", lithuania: "lt", slovakia: "sk", slovenia: "si", croatia: "hr", bulgaria: "bg",
  mexico: "mx", chile: "cl", japan: "jp", "south korea": "kr", "korea, republic of": "kr", korea: "kr",
  philippines: "ph", indonesia: "id", malaysia: "my", thailand: "th", vietnam: "vn", "viet nam": "vn",
  egypt: "eg", nigeria: "ng", kenya: "ke", morocco: "ma", jordan: "jo", qatar: "qa", bahrain: "bh",
  kuwait: "kw", oman: "om", pakistan: "pk", bangladesh: "bd", "sri lanka": "lk", georgia: "ge",
  armenia: "am", moldova: "md", belarus: "by", bosnia: "ba", "north macedonia": "mk", albania: "al",
  montenegro: "me", uruguay: "uy", "costa rica": "cr", panama: "pa", "puerto rico": "pr", ecuador: "ec",
  venezuela: "ve", guatemala: "gt", "dominican republic": "do", monaco: "mc", liechtenstein: "li",
  andorra: "ad", gibraltar: "gi", "cayman islands": "ky", bermuda: "bm",
};

export function countryCode(country) {
  if (!country) return null;
  const key = String(country).trim().toLowerCase();
  if (COUNTRY_CODES[key]) return COUNTRY_CODES[key];
  // Already a two-letter code ("US", "de"), which a hand-typed row can carry.
  return /^[a-z]{2}$/.test(key) ? key : null;
}

export default function Flag({ country, className = "" }) {
  const code = countryCode(country);
  if (!code) return null;
  return (
    <img
      className={`crm-flag ${className}`.trim()}
      src={`https://flagcdn.com/20x15/${code}.png`}
      srcSet={`https://flagcdn.com/40x30/${code}.png 2x`}
      width="16"
      height="12"
      alt={code.toUpperCase()}
      title={country}
      loading="lazy"
    />
  );
}
